module.exports = __webpack_public_path__ + "static/media/tnw.84a6c7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/tnw.png
// module id = 1801
// module chunks = 147